import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import styles from './BookingList.module.css'
import connectToStores from '../../utils/connectToStores'
import FormStore from '../../stores/FormStore'
import FormActions from '../../actions/FormActions'
import BookingStore from '../../stores/BookingStore'
import BookingActions from '../../actions/BookingActions'

import { Booking } from '../index'

function sortDate (a, b) {
  return new Date(a.pickUpTimeStamp) - new Date(b.pickUpTimeStamp)
}

class BookingList extends Component {
  static propTypes = {
    bookings: PropTypes.arrayOf(PropTypes.object),
    showDepartureField: PropTypes.bool
  }
  static defaultProps = {
    bookings: [],
    showDepartureField: false
  }
  static getStores () {
    return [BookingStore, FormStore]
  }
  static getPropsFromStores () {
    return {
      bookings: BookingStore.getState().bookings,
      showDepartureField: FormStore.getState().showDepartureField
    }
  }

  cancelBooking (orderId) {
    BookingActions.removeBooking(orderId)
  }

  sendConfirmation (orderId, email, cb) {
    FormActions.sendConfirmation(orderId, email, cb)
  }

  render () {
    return (
      <section>
        <h1>Bokade bilar</h1>

        {this.props.bookings.length > 0 ?
          this.props.bookings
            .sort(sortDate)
            .filter(booking => moment(booking.pickUpTimeStamp).diff(moment(), 'hours') > -24)
            .map((booking, i) =>
            <Booking
              booking={booking}
              cancelBooking={this.cancelBooking}
              key={`booking_${i}`} 
              sendConfirmation={this.sendConfirmation}
              showDepartureField={this.props.showDepartureField}
            />
          )
        : <div className={styles.noBookings}><em>Inga bokningar</em></div>}

      </section>
    )
  }
}

export default connectToStores(BookingList)
